import React, { useEffect, useState } from "react";
import { Select, SelectItem } from "carbon-components-react";
import http from "../../http-common";
import { toast } from "react-toastify";
import { Controller } from "react-hook-form";

const DistrictCombo = ({ id, name, label, disabled, control, items }) => {
  const [districts, setDistricts] = useState([]);

  useEffect(() => {
    setDistricts(items || []);
  }, [items]);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Select {...field} id={id} labelText={label} disabled={disabled}>
          <SelectItem text="" value="" />
          {districts.map((p) => (
            <SelectItem text={p.description} value={p.id} key={p.id} />
          ))}
        </Select>
      )}
    />
  );
};

DistrictCombo.defaultProps = {
  disabled: false,
  items: [],
};

export default DistrictCombo;
